import { RefObject } from 'react';
import { Color, TypographySize, Weight } from '~/types';
import { removeHTMLElement } from '~/utils/helpers';
import './typography.scss';

type Props = {
    className?: string;
    component?: string;
    children: any;
    color?: Color;
    size?: TypographySize;
    weight?: Weight;
    props?: any;
    numberOfLines?: number;
    customRef?: RefObject<HTMLParagraphElement>;
    selectable?: boolean;
    onClick?: () => void;
};

export default function Typography({
    component,
    className = '',
    color = 'dark',
    size = 16,
    weight = 'regular',
    children,
    numberOfLines,
    customRef,
    selectable = true,
    ...props
}: Props): JSX.Element {
    const Component = component ? 'span' : 'p';

    return (
        <Component
            {...props}
            ref={customRef}
            title={numberOfLines ? children : ''}
            className={`typography size-${size} color-${color} Mulish-${weight} ${
                !selectable ? 'not-selectable' : ''
            } ${className}`}
            style={{ WebkitLineClamp: numberOfLines, overflow: numberOfLines ? 'hidden' : 'none' }}
        >
            {typeof children === 'string' ? removeHTMLElement(children) : children}
        </Component>
    );
}
